<template>
<div v-if="$route.meta.header" class="header-s header-transparent-dark" style="display:block">
  <div class="page-title has-subtitle">
      <div class="page-title-center">
        <router-link :to="{ path: 'home' }" class="icon_home_main">
          <img v-if="$router.currentRoute.path == '/menu' 
            || $router.currentRoute.path == '/talent-profiling-guide' 
            || $router.currentRoute.path == '/perks' 
            || $router.currentRoute.path == '/bussiness-opportunity-support-scheme' 
            || $router.currentRoute.path == '/question-set-a'
            || $router.currentRoute.path == '/question-set-b'
            || $router.currentRoute.path == '/question-set-c'
            || $router.currentRoute.path == '/question-set-d'
            || $router.currentRoute.path == '/question-set-e'
            || $router.currentRoute.path == '/question-set-f'
            || $router.currentRoute.path == '/question-set-g'
            || $router.currentRoute.path == '/talent-result'
            || $router.currentRoute.path == '/career-lifestyle-survey' 
            || $router.currentRoute.path == '/career-disturb'
            || $router.currentRoute.path == '/career-solution'
            || $router.currentRoute.path == '/career-result'
          " v-bind:src="'images/mpower-new/logo-icon/Logomark-Red.png'" class="logo-mpower-title">
          <img v-else v-bind:src="'images/mpower-new/logo-icon/Logomark-White.png'" class="logo-mpower-title">
        </router-link>
      </div>
  </div>


	<div class="header header-fixed header-logo-app header-auto-show">
      <router-link :to="{ path: 'home' }">
        <img v-bind:src="'images/mpower-new/logo-icon/Logomark-White.png'" class="logo-mpower">
      </router-link>
	</div>
  
	</div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
